import { ICON } from "../../Icons/Icons";

export const UserListPanel = () => `
<div class="chat-panel users-panel">
    <div class="panel-header">
        <span class="header-title" data-lang="people-text">People</span>
        <span class="header-sub-title"></span>
        <div class="header-actions">
            <div class="header-actions__close-btn">${ICON.CLOSE}</div>
        </div>
    </div>

    <div class="switch-button-wrapper"></div>
    <div class="chat-body-wrapper" id="user-list-scene">
        <div class="list-container scene-container folded">
        </div>
        <div class="list-container room-container folded">
        </div>
    </div>
    <div class="chat-body-wrapper" id="user-list-participants">
        <div class="list-container tour-container folded">
        </div>
        <div class="list-container invite-to-tour-container folded">
        </div>
        <div class="list-container pending-invitation-container folded">
        </div>
    </div>
    <div class="chat-body-wrapper" id="user-list-friends">
        <div class="list-container friends-container folded">
        </div>
    </div>
</div>
`;

export const UserListMobilePanel = ({ title }) => `
<div class="chat-panel mobile-users-panel">
    <div class="panel-header">
        <div class="header-left">
            <button class="back-button" aria-label="Go back">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M4.00483 11.6175C3.9563 11.7345 3.92935 11.8628 3.92896 11.9973L3.92896 12.0033C3.92972 12.2582 4.02734 12.5129 4.22184 12.7074L11.2929 19.7784C11.6834 20.169 12.3166 20.169 12.7071 19.7784C13.0976 19.3879 13.0976 18.7548 12.7071 18.3642L7.34316 13.0003H19.0711C19.6234 13.0003 20.0711 12.5526 20.0711 12.0003C20.0711 11.448 19.6234 11.0003 19.0711 11.0003L7.34316 11.0003L12.7071 5.63631C13.0976 5.24578 13.0976 4.61262 12.7071 4.22209C12.3166 3.83157 11.6834 3.83157 11.2929 4.22209L4.22233 11.2927L4.21973 11.2953C4.1249 11.3907 4.05327 11.5004 4.00483 11.6175Z" fill="white"/>
                </svg>
            </button>
            <span class="header-title">${title}</span>
        </div>
        <div class="header-actions">
            ${ICON.CLOSE}
        </div>
    </div>
    <div class="chat-body-wrapper"></div>
</div>
`;
